import React from "react";
import { toast } from "react-toastify";
import { Archive as ArchiveIcon } from "@material-ui/icons";
import { Item } from "../Item";
import { Button } from "./styles";
import { useTranslation } from "react-i18next";
import { API } from "../../../../../shared/services";
import { useContacts } from "../../../contexts";

export default function Archive({ customer }) {
  const { updateCurrentContact } = useContacts();
  const { t } = useTranslation("Customer");

  function handleClick() {
    const ARCHIVE_STATUS = "filed";

    API.put(`customers/${customer.id}`, {
      customer: {
        status: ARCHIVE_STATUS,
      },
    })
      .then(() => {
        updateCurrentContact({
          ...customer,
          status: "filed",
        });

        toast.success(t("details.archive.actionSuccess"));
      })
      .catch(() => {
        toast.success(t("details.archive.actionFail"));
      });
  }

  return (
    <Item>
      <Button
        onClick={handleClick}
        variant="outlined"
        data-testid="archive-action"
      >
        <ArchiveIcon style={{ float: "left" }} />
        <span>{t("details.archive.action")}</span>
      </Button>
    </Item>
  );
}
